<script setup lang="ts">
import { useWebSocketStore } from '@/stores/useWebSocketStore'
import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useToast } from 'vue-toast-notification'

const toast = useToast()

const webSocketStore = useWebSocketStore()
const { notification } = storeToRefs(webSocketStore)

watch(
  notification,
  (newNotification) => {
    if (!newNotification) return

    const messageWithTime = newNotification.message

    toast.open({
      message: messageWithTime,
      type: newNotification.type,
      onClick: () => {},
    })
    notification.value = null
  },
  { deep: true },
)
</script>
<template><span></span></template>
